module.exports = __webpack_public_path__ + "static/media/iconCommandActive.f751ae96.svg";